// useEnrichedCrew.js, Fetches enriched astronaut data from Launch Library 2
// via our backend /api/crew/enriched endpoint. Cached 1 hour server-side.
// Refreshes client-side every 30 minutes.

import { useState, useEffect } from 'react';

const API = import.meta.env.VITE_API_BASE || '/api';

export function useEnrichedCrew() {
  const [crew, setCrew] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fetchedAt, setFetchedAt] = useState(null);

  useEffect(() => {
    let cancelled = false;
    function load() {
      setLoading(true);
      fetch(`${API}/crew/enriched`)
        .then(r => r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`))
        .then(d => {
          if (cancelled) return;
          setCrew(d.crew || []);
          setFetchedAt(d.fetched_at);
          setError(null);
        })
        .catch(e => {
          if (!cancelled) setError(String(e));
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }
    load();
    const id = setInterval(load, 30 * 60 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return { crew, loading, error, fetchedAt };
}
